"use client";

import VideoCard from "./VideoCard";
import styles from "./styles.module.scss";


const CARD_OVERRIDES = [
  {
    Description:
      "MasterClass by Amity University Online | How to write a perfect CV",
    Name: "Mr. Satyam Khandelwal, Career Growth Expert",
  },
  {
    Description:
      "MasterClass on 'Key Skills to be Highly Employable' | Amity University Online | Career Tips",
    Name: "Mr. Anshuman Tiwar, Quality Leader and Career Growth Expert",
  },
  {
    Description:
      "MasterClass on 'Effective Tips For Career Planning' | Amity University Online | Professional Growth",
    Name: "Dr. Jayasri Benkal, Leadership Coach and Business Consultant",
  },
];

export default function VideoWithTitleSection({ data }) {
  return (
    <div className={styles.root}>
      {data?.map((videoData, i) => {
        const video = { ...videoData, ...CARD_OVERRIDES[i] };
        return (
          <VideoCard key={video?.URL || i} video={video} isFirst={i === 0} />
        );
      })}
    </div>
  );
}
